import React from 'react';
import { MailHistoryContainerStyled } from './styled';
import { withRouter } from 'navigations/withRouter';
import { Buttons, Displays, Inputs, Modals, Tables } from 'components';
import { scrollToTopPageFN } from 'utils/functions/scrollTopPage';
import { portalService } from 'apiServices';
import { toast } from 'react-toastify';
import {
  MdEventBusy,
  MdNotificationsActive,
  MdSchedule,
  MdSend,
} from 'react-icons/md';
import moment from 'moment';
import 'moment-timezone';
import {
  MAIL_STATUS_OPTIONS,
  MAIL_TYPE_OPTIONS,
  RENDER_MAIL_STATUS,
  RENDER_MAIL_TRIGGER,
  RENDER_MAIL_TYPE,
} from 'utils/functions/mailLog';
import MailLogDetailContainer from './Modals/MailLogDetailContainer';

const TIME_ZONE = 'Asia/Bangkok';

const FILTER_FIELDS = ['keyword', 'type', 'status', 'start_date', 'end_date'];

// แปลง query string ของ url เป็น state ของ filter (ใช้ตอนเข้าหน้าครั้งแรก / กด refresh)
const parseUrlQuery = (search) => {
  const searchParams = new URLSearchParams(search || '');
  const currentPage = Number(searchParams.get('page')) || 1;
  let filterValues = {};
  FILTER_FIELDS.forEach((key) => {
    filterValues[key] = searchParams.get(key) || '';
  });
  Array.from(searchParams.keys()).forEach((key) => {
    if (FILTER_FIELDS.indexOf(key) === -1 || !searchParams.get(key)) {
      searchParams.delete(key);
    }
  });
  const filterString = searchParams.toString();
  return {
    filterQuery: filterString ? `?${filterString}` : '',
    filterValues,
    currentPage,
  };
};

class MailHistoryContainer extends React.Component {
  state = {
    isLoading: true,
    pagination: null,
    perPage: 10,
    data: [],
    filterKey: 0,
    renderModal: false,
    ...parseUrlQuery(this.props.router.location.search),
  };

  componentDidMount() {
    const { filterQuery, currentPage } = this.state;
    scrollToTopPageFN();
    this.handleJoinQuery(filterQuery, currentPage);
  }

  fetchData = async (stringQuery) => {
    let res = await portalService.GET_MAIL_LOG_LIST(stringQuery);
    if (res && res.status === 200) {
      this.setState({
        data: res.data.docs,
        isLoading: false,
        pagination: {
          last_page: res.data.totalPages,
          current_page: res.data.page,
        },
      });
    } else {
      this.setState({ isLoading: false });
    }
  };

  handleJoinQuery = (query, page) => {
    const { perPage } = this.state;
    let joinQuery = query
      ? `${query}&limit=${perPage}&page=${page}`
      : `?limit=${perPage}&page=${page}`;
    this.setState({
      isLoading: true,
      currentPage: page,
    });
    this.handleSyncUrlQuery(query, page);
    this.fetchData(joinQuery);
  };

  handleSyncUrlQuery = (query, page) => {
    const searchParams = new URLSearchParams(query || '');
    Array.from(searchParams.keys()).forEach((key) => {
      if (!searchParams.get(key)) {
        searchParams.delete(key);
      }
    });
    if (page > 1) {
      searchParams.set('page', page);
    }
    const search = searchParams.toString();
    this.props.router.navigate(
      { search: search ? `?${search}` : '' },
      { replace: true }
    );
  };

  handleReloadCurrentPage = () => {
    const { filterQuery, currentPage } = this.state;
    this.handleJoinQuery(filterQuery, currentPage);
  };

  handleFilterKeyword = (e) => {
    const parsedQuery = parseUrlQuery(e);
    this.setState({
      ...parsedQuery,
    });
    this.handleJoinQuery(parsedQuery.filterQuery, 1);
  };

  handleClearFilter = () => {
    this.setState((prevState) => ({
      ...parseUrlQuery(''),
      filterKey: prevState.filterKey + 1,
    }));
    this.handleJoinQuery('', 1);
  };

  handlePageClick = (e) => {
    const { filterQuery } = this.state;
    this.handleJoinQuery(filterQuery, e.selected + 1);
  };

  handleCloseModal = () => {
    this.setState({ renderModal: false });
  };

  handleClickDetail = (row) => {
    this.setState({
      renderModal: (
        <MailLogDetailContainer
          id={row._id}
          onResent={this.handleResent}
          onClose={this.handleCloseModal}
        />
      ),
    });
  };

  handleResent = () => {
    this.handleCloseModal();
    this.handleJoinQuery(this.state.filterQuery, 1);
  };

  handleClickRunAlert = () => {
    this.setState({
      renderModal: (
        <div className="confirm_modal">
          <div className="confirm_icon">
            <MdSend size={22} />
          </div>
          <div className="confirm_title">ส่งเมลแจ้งเตือนตอนนี้?</div>
          <div className="confirm_desc">
            ระบบจะตรวจของรางวัลที่หมดอายุและใกล้หมดอายุ (ภายใน 1 เดือน)
            แล้วส่งเมลเฉพาะรายการที่ยังไม่เคยแจ้ง ถ้าไม่มีรายการใหม่จะไม่ส่งเมล
          </div>
          <div className="confirm_action">
            <div className="btn_box">
              <Buttons.BgStandard
                theme_gray
                label="ยกเลิก"
                onClick={this.handleCloseModal}
              />
            </div>
            <div className="btn_box">
              <Buttons.BgStandard
                label="ยืนยันส่ง"
                onClick={this.runAlertAction}
              />
            </div>
          </div>
        </div>
      ),
    });
  };

  runAlertAction = async () => {
    if (this.isRunning) return;
    this.isRunning = true;
    this.setState({ renderModal: false, isBgLoading: true });
    let res = await portalService.POST_MAIL_REWARD_EXPIRE_ALERT_RUN();
    this.isRunning = false;
    this.setState({ isBgLoading: false });
    if (res && res.status === 200) {
      const results = res.data || [];
      const sent = results.filter((e) => e.status !== 'skip');
      if (sent.length === 0) {
        toast.info('ไม่มีของรางวัลรายการใหม่ที่ต้องแจ้งเตือน จึงไม่ได้ส่งเมล');
      }
      results.forEach((e) => {
        const label = `${RENDER_MAIL_TYPE(e.type)} ${e.item_count} รายการ`;
        if (e.status === 'success') {
          toast.success(`ส่งเมล${label} สำเร็จ`);
        } else if (e.status === 'fail') {
          toast.error(
            `ส่งเมล${label} ไม่สำเร็จ: ${e.error_message || 'ไม่ทราบสาเหตุ'}`
          );
        }
      });
      this.handleJoinQuery(this.state.filterQuery, 1);
    } else {
      const message =
        (res && res.data && res.data.error && res.data.error.message) ||
        'ส่งเมลไม่สำเร็จ';
      toast.error(message);
    }
  };

  render() {
    const {
      isLoading,
      isBgLoading,
      pagination,
      data,
      filterValues,
      filterKey,
      renderModal,
    } = this.state;

    return (
      <MailHistoryContainerStyled>
        <Displays.BGLoading visible={isBgLoading} />
        <div className="alert_card">
          <div className="alert_icon">
            <MdNotificationsActive size={24} />
          </div>
          <div className="alert_body">
            <div className="alert_title">
              แจ้งเตือนของรางวัลหมดอายุ / ใกล้หมดอายุ
            </div>
            <div className="alert_meta">
              <span className="meta_chip">
                <MdSchedule size={14} />
                ส่งอัตโนมัติทุกวัน 08:30 น.
              </span>
              <span className="meta_chip">
                <MdEventBusy size={14} />
                หมดอายุ + ล่วงหน้า 1 เดือน
              </span>
            </div>
          </div>
          <div className="btn_run">
            <Buttons.BgIconPrefix
              label="ตรวจสอบและส่งเมลตอนนี้"
              icon={<MdSend size={16} />}
              onClick={this.handleClickRunAlert}
            />
          </div>
        </div>
        <div className="filter_layout">
          <Inputs.InputFilter
            key={filterKey}
            theme_standard_input_filter
            dataFilter={dataFilter(filterValues)}
            btnLabel="ค้นหา"
            clearLabel="ล้างค่า"
            onQueryFilter={this.handleFilterKeyword}
            onClear={this.handleClearFilter}
          />
        </div>
        {isLoading ? (
          <Displays.Loading theme_standard_loading heightLayout="470px" />
        ) : (
          <Tables.Standard
            columns={columns}
            data={data}
            onRowClick={this.handleClickDetail}
            showPagination
            pagination={pagination}
            handlePageClick={this.handlePageClick}
          />
        )}
        <Modals.BodyEmpty
          isShowModal={renderModal}
          onCloseModal={this.handleCloseModal}
        >
          {renderModal}
        </Modals.BodyEmpty>
      </MailHistoryContainerStyled>
    );
  }
}

const dataFilter = (filterValues) => [
  {
    accessor: 'keyword',
    length: '311px',
    filter: {
      fieldQuery: 'keyword',
      type: 'text',
      defaultValue: filterValues.keyword,
      label: 'Keyword : ',
      placeholder: 'หัวข้อ / ผู้รับ / ชื่อหรือรหัสของรางวัล',
    },
  },
  {
    accessor: 'type',
    length: '311px',
    filter: {
      fieldQuery: 'type',
      type: 'dropdown',
      defaultValue: filterValues.type,
      options: MAIL_TYPE_OPTIONS,
      placeholder: 'Mail type',
      label: 'Mail type : ',
    },
  },
  {
    accessor: 'status',
    length: '200px',
    filter: {
      fieldQuery: 'status',
      type: 'dropdown',
      defaultValue: filterValues.status,
      options: MAIL_STATUS_OPTIONS,
      placeholder: 'Status',
      label: 'Status : ',
    },
  },
  {
    accessor: 'date',
    filter: {
      fieldQuery: 'date',
      type: 'dateRank',
      defaultStartValue: filterValues.start_date,
      defaultEndValue: filterValues.end_date,
      label: 'Date Range : ',
    },
  },
];

const columns = [
  {
    Header: <div style={{ textAlign: 'left' }}>Date</div>,
    accessor: 'created_at',
    Cell: (props) =>
      props.value
        ? moment(props.value).tz(TIME_ZONE).format('DD/MM/YYYY HH:mm')
        : '-',
  },
  {
    Header: <div style={{ textAlign: 'left' }}>Mail type</div>,
    accessor: 'type',
    Cell: (props) => RENDER_MAIL_TYPE(props.value),
  },
  {
    Header: <div style={{ textAlign: 'left' }}>Subject</div>,
    accessor: 'subject',
    Cell: (props) => <div className="subject_cell">{props.value || '-'}</div>,
  },
  {
    Header: <div style={{ textAlign: 'left' }}>To</div>,
    accessor: 'to',
    Cell: (props) =>
      props.value && props.value.length > 0 ? props.value.join(', ') : '-',
  },
  {
    Header: <div style={{ textAlign: 'right' }}>Items</div>,
    accessor: 'item_count',
    Cell: (props) => (
      <div style={{ textAlign: 'right' }}>{Number(props.value || 0)}</div>
    ),
  },
  {
    Header: <div style={{ textAlign: 'left' }}>Sent by</div>,
    accessor: 'trigger',
    Cell: (props) => (
      <div>
        {RENDER_MAIL_TRIGGER(props.value)}
        {props.row.original.admin_username && (
          <div className="sub_text">{props.row.original.admin_username}</div>
        )}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: 'center' }}>Status</div>,
    accessor: 'status',
    Cell: (props) => (
      <div style={{ textAlign: 'center' }}>
        <span className={`status_badge status_${props.value}`}>
          {RENDER_MAIL_STATUS(props.value)}
        </span>
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: 'left' }}>Reason</div>,
    accessor: 'error_message',
    Cell: (props) =>
      props.value ? (
        <div className="error_text" title={props.value}>
          {props.value}
        </div>
      ) : (
        '-'
      ),
  },
];

export default withRouter(MailHistoryContainer);
